import { signal } from '@angular/core';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const mediaQuery = window.matchMedia?.(REDUCED_MOTION_QUERY);

const reducedMotion = signal(mediaQuery?.matches ?? false);

// The OS setting can be flipped while the app is open. One listener for the
// whole app, so it is never removed.
mediaQuery?.addEventListener('change', (event) => reducedMotion.set(event.matches));

/**
 * True when the visitor has asked their OS to minimize animation.
 *
 * A split-flap board is continuous motion by nature, so anything that animates
 * should read this and settle straight to its target instead. It is a signal
 * rather than a one-shot read so that turning the setting on takes effect
 * immediately, without a reload.
 */
export const prefersReducedMotion = reducedMotion.asReadonly();
